import React from 'react'
import { EntityType, IDailyReportResult, Status } from 'orders/dailySchedule/schemas'
import Badge, { BadgeVariant } from 'uiComponents/badge'
import ClockRegular from '../icons/clockRegular.svg'
import LocationRegular from '../icons/locationRegular.svg'
import { useTranslation } from 'translations'

const getBadgeVariant = (status: Status): BadgeVariant => {
    switch (status) {
        case Status.OVERDUE:
        case Status.EXPIRED:
        case Status.PENDING:
            return 'error'
        case Status.INITIATED:
            return 'info'
        case Status.PAID:
        case Status.CONFIRMED:
            return 'success'
        default:
            return 'neutral'
    }
}

const InfoColumn = ({ dailyReportResult }: { dailyReportResult: IDailyReportResult }) => {
    const { t } = useTranslation()

    // The status comes from the backend as an English enum value; unknown values are shown as they are.
    const getStatusLabel = (status: Status): string => {
        switch (status) {
            case Status.INITIATED:
                return t('orders.dailySchedule.status.initiated')
            case Status.OVERDUE:
                return t('orders.dailySchedule.status.overdue')
            case Status.PENDING:
                return t('orders.dailySchedule.status.pending')
            case Status.EXPIRED:
                return t('orders.dailySchedule.status.expired')
            case Status.COMPLETED:
                return t('orders.dailySchedule.status.completed')
            case Status.PAID:
                return t('orders.dailySchedule.status.paid')
            case Status.CONFIRMED:
                return t('orders.dailySchedule.status.confirmed')
            default:
                return status
        }
    }

    return (
        <div className="info-column-container">
            <div>
                {dailyReportResult.visitTime && (
                    <div className="event-time-container">
                        <ClockRegular className="clock-icon" />
                        <span className="event-time" title={dailyReportResult.visitTime}>
                            {dailyReportResult.visitTime.slice(0, 5)}
                        </span>
                    </div>
                )}
                {dailyReportResult.location && (
                    <div className="event-location-container" title={dailyReportResult.location.name}>
                        <LocationRegular className="location-icon" />
                        <div className="event-location" title={dailyReportResult.location.name}>
                            {dailyReportResult.location.name}
                        </div>
                    </div>
                )}
            </div>
            <div className="badges-container">
                <Badge
                    variant="info"
                    label={
                        dailyReportResult.entityType === EntityType.RESERVATION
                            ? t('orders.dailySchedule.reservationBadge', { id: dailyReportResult.entityId })
                            : t('orders.dailySchedule.orderBadge', { id: dailyReportResult.entityId })
                    }
                />
                {dailyReportResult.status && (
                    <Badge variant={getBadgeVariant(dailyReportResult.status)} label={getStatusLabel(dailyReportResult.status)} />
                )}
            </div>
        </div>
    )
}

export default InfoColumn
